import { nothing } from "lit";
const rif = (predicate, content) => predicate ? content : nothing;
export {
  rif
};
